<template>
    <div>
        <config-main-title>
            Categorias Financeiras
        </config-main-title>

        <div v-if="!id_modelo_categoria">

            <div class="form-row my-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search">
                    </az-input>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                            @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                            @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir_modelo ()">
                        Incluir Modelo
                    </button>
                </div>            
            </div>

            <div class="alert alert-info">
                <strong>Modelos de Categorias Financeiras</strong><br> 
                Existe o modelo base, utilizado para realização dos lançamentos no sistema, e a possibilidade de criar outros modelos pra diferentes visualizações de DRE e Fluxo de Caixa.
            </div>

            <az-empty-state v-if="!lista_modelos.length" msg="Nenhum modelo identificado." />

            <ul class="list-group">
                <li class="list-group-item d-flex justify-content-between h5 mb-0" v-for="(modelo, imx) in lista_modelos" :key="imx">
                    <div>
                        <span v-if="isNaN(modelo.id_modelo_categoria)">
                            {{ modelo.st_titulo }}
                        </span>
                        <a href="#" @click.prevent="editarModelo(modelo)" class="card-link" v-else>
                            {{ modelo.st_titulo }}
                        </a>
                    </div>
                    <div>
                        <template v-if="viewMode == 'T'">
                            <span v-if="!isNaN(modelo.id_modelo_prontuario)">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" 
                                        :id="'modelo-' + imx" 
                                        v-model="modelo.fl_ativo"
                                        @change="toggle_modelo(modelo)">
                                    <label class="custom-control-label" :for="'modelo-' + imx"></label>
                                </div>
                            </span>
                            <span v-else>
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" 
                                        :disabled="isNaN(modelo.id_modelo_categoria)"
                                        :id="'modelo-' + imx" 
                                        v-model="modelo.fl_ativo"
                                        @change="toggle_modelo(modelo)">
                                    <label class="custom-control-label" :for="'modelo-' + imx"></label>
                                </div> 
                            </span>
                        </template>

                        <template v-else>
                            <a href="#" @click.prevent="selecionar_modelo(modelo)" class="ml-3" title="Editar Categorias">
                                <i class="fa-solid fa-rectangle-list"></i>
                            </a>
                        </template>
                    </div>
                </li>
            </ul>

        </div>

        <div v-else-if="dados && dados.categorias">

            <ul class="nav nav-pills" id="myTab" role="tablist">
                <li class="nav-item" role="presentation">
                    <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">
                        Lista
                    </a>
                </li>
                <li class="nav-item" role="presentation" v-if="apuracao == 'O' && isNaN(id_modelo_categoria)">
                    <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">
                        Entradas
                    </a>
                </li>
                <li class="nav-item" role="presentation">
                    <a class="nav-link" href="#" role="tab" aria-controls="profile" aria-selected="false" @click.prevent="id_modelo_categoria = null;">
                        Voltar
                    </a>
                </li>
            </ul>
            
            <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">

                    <div class="form-row my-3">
                        <div class="col col-12 col-md-6 d-flex flex-column">
                            <az-input icon="fas fa-search" v-model="search">
                                <template v-slot:buttonposb>
                                    <importacao service="categorias" @refresh="load()" v-if="isNaN(id_modelo_categoria)">
                                        <template v-slot:instrucao>
                                            <p class="alert alert-info">
                                                O campo natureza deve ser preenchido com C (Crédito) ou D (Débito).
                                            </p>
                                        </template>
                                    </importacao>
                                    <print-export printid="lista-categorias" :dados="dados_tabela" />

                                    <div class="input-group-append">
                                        <button type="button" class="btn btn-outline-primary" 
                                            @click="incluirCategoria ({ id_categoria: null, id_categoria_mae: null, ch_natureza: chave, categoria_mae: null }, true)">
                                            <i class="fa fa-plus" aria-hidden="true"></i>
                                        </button>

                                        <button type="button" class="btn btn-outline-primary" 
                                            v-if="id_modelo_categoria && !isNaN(id_modelo_categoria)"
                                            @click="incluirCategoria ({ id_categoria: null, id_categoria_mae: null, ch_natureza: chave, categoria_mae: null }, true, true)">
                                            <i class="fa-solid fa-square-root-variable"></i>
                                        </button>
                                    </div>
                                </template>
                            </az-input>
                        </div>
                        <div class="col col-12 col-md-3 d-flex flex-column">
                            <div class="btn-group mb-1" role="group" aria-label="Basic example">
                                <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                                    @click="viewMode = 'A'">
                                    Ativos
                                </button>
                                <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                                    @click="viewMode = 'T'">
                                    Todos
                                </button>
                            </div>
                        </div>

                        <div class="col col-12 col-md-3 d-flex flex-column">
                            <button type="button" class="btn btn-primary text-truncate" disabled v-if="!isNaN(id_modelo_categoria) && modelo_selecionado">
                                {{ modelo_selecionado.st_titulo }}
                            </button>

                            <template v-else>
                                <div class="btn-group mb-1" role="group" aria-label="Basic example">
                                    <button type="button" class="btn" :class="tipo_aplic == 'G' ? 'btn-secondary' : 'btn-outline-secondary'" 
                                        @click="trocar_tipo_aplic('G')">
                                        Geral
                                    </button>
                                    <button type="button" class="btn" :class="tipo_aplic == 'D' ? 'btn-secondary' : 'btn-outline-secondary'" 
                                        @click="trocar_tipo_aplic('D')">
                                        DRE
                                    </button>
                                    <button type="button" class="btn" :class="tipo_aplic == 'F' ? 'btn-secondary' : 'btn-outline-secondary'" 
                                        @click="trocar_tipo_aplic('F')">
                                        F. Caixa
                                    </button>
                                </div>
                            </template>
                        </div>

                        <div class="col col-12 col-md-2 d-flex flex-column" v-if="false">
                            <button type="button" class="btn btn-outline-success" 
                                @click="incluirCategoria ({ id_categoria: null, id_categoria_mae: null, ch_natureza: chave, categoria_mae: null }, true)">
                                Incluir
                            </button>
                        </div>
                    </div>

                    <div class="text-right">
                        <a href="#" @click.prevent="toggle_expanded()" class="card-link">
                            <i class="fa-solid fa-maximize" v-if="!expanded"></i>
                            <i class="fa-solid fa-minimize" v-else></i>
                        </a>
                    </div>

                    <template v-if="1==1">

                        <div id="lista-categorias" v-if="tipo_aplic">

                            <cabecalho-generico titulo="Categorias Financeiras">
                            </cabecalho-generico>

                            <template v-if="tipo_aplic == 'D' || !isNaN(id_modelo_categoria)">
                                <categorias-hierarquia 
                                    ref="categ"
                                    :id_modelo_categoria="id_modelo_categoria"
                                    :tipo_aplic="isNaN(id_modelo_categoria) ? tipo_aplic : 'D'"
                                    :value="dados" 
                                    natureza="G"
                                    :view="viewMode" 
                                    :search="search" 
                                    :expansao="expansao"
                                    @expandir="expandir"
                                    @refresh="load()"
                                    @editar="editar"
                                    @toggle="toggle"
                                    @incluir="incluirCategoria"
                                    @incluir_sub="incluirSubCategoria" />  
                            </template>

                            <template v-else>

                                <az-break-title title="Entradas" />
                                <categorias-hierarquia 
                                    :id_modelo_categoria="id_modelo_categoria"
                                    :tipo_aplic="tipo_aplic"
                                    :value="dados" 
                                    natureza="C"
                                    :view="viewMode" 
                                    :search="search" 
                                    :expansao="expansao"
                                    @expandir="expandir"
                                    @refresh="load()"
                                    @editar="editar"
                                    @toggle="toggle"
                                    @incluir="incluirCategoria"
                                    @incluir_sub="incluirSubCategoria" />

                                <az-break-title title="Saídas" />
                                <categorias-hierarquia 
                                    :id_modelo_categoria="id_modelo_categoria"
                                    :tipo_aplic="tipo_aplic"
                                    :value="dados" 
                                    natureza="D"
                                    :view="viewMode" 
                                    :search="search" 
                                    :expansao="expansao"
                                    @expandir="expandir"
                                    @refresh="load()"
                                    @editar="editar"
                                    @toggle="toggle"
                                    @incluir="incluirCategoria"
                                    @incluir_sub="incluirSubCategoria" />

                            </template>

                        </div>

                        <br><br><br>
                    </template>

                    <template v-else>

                        <div id="lista-categorias">

                            <div v-for="(grupo, chave, igx) in lista" :key="'G' + igx">

                                <az-break-title :title="chave == 'D' ? 'Saídas' : 'Entradas'">
                                    <a href="#" @click.prevent="incluirCategoria ({ id_categoria: null, ch_natureza: chave })" class="mr-2" data-toggle="tooltip" data-placement="top" 
                                        :title="'Incluir Categoria de ' + ( chave == 'D' ? 'Saídas' : 'Entradas' )">
                                        <i class="fas fa-plus text-success"></i>
                                    </a>
                                </az-break-title>

                                <div class="list-group mb-3 az-anime-surgir mb-3">
                                    <draggable v-model="lista[chave]" @start="drag=true" @end="drag=false; atualizarOrdem(chave);" ghost-class="primary">

                                        <li class="list-group-item" v-for="(dado, id) in grupo" :key="id">
                                            <div class="d-flex justify-content-between">
                                                <span>
                                                    <button type="button" class="btn btn-link p-0" data-toggle="collapse" :href="'.collapse-' + igx + '-' + id" v-if="dado.fl_ativa">
                                                        <span class="h5 card-link mb-0 mr-3">
                                                            {{ dado.search }}
                                                        </span>
                                                    </button>
                                                    <span class="h5 card-link mb-0 mr-3" v-else>
                                                        {{ dado.search }}
                                                    </span>
                                                    <span class="badge badge-secondary mr-3">#{{ dado.id_categoria }}</span>
                                                </span>
                                                <span class="d-flex">
                                                    <div class="collapse multi-collapse mr-3" :class="'collapse-' + igx + '-' + id">
                                                        <a href="#" class="card-link text-success" data-toggle="tooltip" data-placement="top" title="Editar Nível Hierárquico"
                                                            @click.prevent="editar(dado)">
                                                            <i class="fas fa-edit text-primary mr-2"></i>
                                                        </a>
                                                        <a href="#" class="card-link text-success" data-toggle="tooltip" data-placement="top" title="Incluir Categoria"
                                                            @click.prevent="incluirCategoria(dado)">
                                                            <i class="fas fa-plus text-success"></i>
                                                        </a>
                                                        <a href="#" class="card-link text-success" data-toggle="tooltip" data-placement="top" title="Incluir Förmula"
                                                            @click.prevent="incluirCategoria(dado, false, true)">
                                                            <i class="fa-solid fa-square-root-variable"></i>
                                                        </a>
                                                    </div>
                                                    <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                                                        <input type="checkbox" class="custom-control-input" 
                                                            :id="'ativo-' + igx + '-' + id" 
                                                            v-model="dado.fl_ativa" 
                                                            @change="toggle(dado)">
                                                        <label class="custom-control-label" :for="'ativo-' + igx + '-' + id"></label>
                                                    </div>
                                                </span>
                                            </div>
                                            <div class="collapse multi-collapse m-3" :class="'collapse-' + igx + '-' + id" :id="'collapse-'  + igx + '-' + id">

                                                <div class="list-group mb-3 az-anime-surgir mb-3">

                                                    <div v-if="dado.categorias.length == 0">
                                                        <button type="button" class="btn btn-outline-primary mr-1" @click="incluirCategoria(dado, true)">
                                                            Incluir Nível Hierárquico
                                                        </button>
                                                        <button type="button" class="btn btn-outline-primary" @click="incluirCategoria(dado)">
                                                            Incluir Categoria
                                                        </button>
                                                    </div>

                                                    <draggable v-model="dado.categorias" @start="drag_cat=true" @end="drag_cat=false; atualizarOrdemFilho(dado);" ghost-class="primary">
                                                        <li class="list-group-item d-flex justify-content-between" v-for="(categoria, ib) in dado.categorias" :key="'C' + id + '-' + ib">
                                                            <span>
                                                                <i class="fas fa-caret-right mr-2" v-if="false"></i>
                                                                <a href="#" @click.prevent="editar(categoria)" class="h5 card-link mb-0 mr-3">
                                                                    {{ categoria.search }}
                                                                    <!--
                                                                    <span class="text-muted">
                                                                        {{ categoria.fl_ativa ? 'Ativa' : 'Inativa' }}
                                                                    </span>
                                                                    -->
                                                                </a>
                                                            </span>
                                                            <span>
                                                                <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                                                                    <input type="checkbox" class="custom-control-input" 
                                                                        :id="'categoria-' + igx + '-' + id + '-' + ib" 
                                                                        v-model="categoria.fl_ativa"
                                                                        @change="toggle(categoria)">
                                                                    <label class="custom-control-label" :for="'categoria-' + igx + '-' + id + '-' + ib"></label>
                                                                </div>
                                                            </span>
                                                        </li>
                                                    </draggable>
                                                </div>

                                            </div>
                                        </li>
                                    </draggable>
                                </div>

                            </div>

                        </div>

                    </template>
                    
                </div>

                <!-- Configuração das Receitas -->
                <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">

                    <div class="card dashcard mt-3">
                        <div class="card-body" v-if="apuracao == 'P' && 1 == 0">
                            <table class="table">
                                <tr v-for="(grupo, iox) in grupos" :key="iox">
                                    <td>
                                        {{ grupo.search }}
                                    </td>
                                    <td>
                                        <az-input
                                            sizing="sm"
                                            type="select"
                                            optionsMode="aql"
                                            optionsName="categorias.lancamento.entradas"
                                            :optionsParm="{ lancamento: true, where: { ch_natureza: 'C' } }"
                                            service="categorias.index" 
                                            optionsData="id_categoria"
                                            v-model="grupo.id_categoria" />
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div class="card-body" v-else>
                            <table class="table">
                                <tr v-for="(operadora, iox) in operadoras" :key="iox">
                                    <td>
                                        {{ operadora.search }}
                                    </td>
                                    <td>
                                        <az-input
                                            sizing="sm"
                                            type="select"
                                            optionsMode="aql"
                                            optionsName="categorias.lancamento.entradas"
                                            :optionsParm="{ lancamento: true, where: { ch_natureza: 'C' } }"
                                            :optionsSync="true"
                                            service="categorias.index" 
                                            optionsData="id_categoria"
                                            v-model="operadora.id_categoria" />
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div class="card-footer">
                            <az-submit @click="atualizarCategoriaEntradas()">Atualizar</az-submit>
                        </div>
                    </div>

                    
                </div>
                
            </div>

        </div>

        <!-- Modal -->
        <div class="modal fade" id="categoriaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{ item.fl_permitir_lancamento ? 'Categoria' : 'Nível Hierárquico' }}
                            {{ ( item && item.id_categoria_mae && item.categoria_mae ) ? ( ' de ' + item.categoria_mae.search ) : '' }}
                            <span class="badge badge-secondary ml-2" v-if="item.id_categoria">
                                #{{ item.id_categoria }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info" v-if="modelo_selecionado">
                            {{ modelo_selecionado.st_titulo }}
                        </div>

                        <template v-if="item.fl_permitir_lancamento">
                            <i class="fa fa-plus-circle text-success fa-2x mb-2" v-if="item.ch_natureza == 'C'"></i>
                            <i class="fa fa-minus-circle text-danger fa-2x mb-2" v-else-if="item.ch_natureza == 'D'"></i>
                            <i class="fa-solid fa-circle-arrow-right text-primary fa-2x mb-2" v-else-if="item.ch_natureza == 'T'"></i>
                        </template>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Nome"
                                    :edicao="!item.vinculo_categoria"
                                    required 
                                    :validate="validate"
                                    v-model="item.st_categoria" />
                            </div>
                        </div>

                        <!-- Ordem -->
                        <div class="row" v-if="!item.vinculo_categoria">
                            <div class="col col-12">
                                <az-input
                                    type="number"
                                    placeholder="Ordem..."
                                    label="Ordem"
                                    :required="item.id_categoria > 0 ? true : false" 
                                    :validate="validate"
                                    v-model="item.in_regra_ordem" />
                            </div>
                        </div>
                        <div class="row" v-else>
                            <div class="col col-12">
                                <az-input
                                    type="number"
                                    placeholder="Ordem..."
                                    label="Ordem (Modelo)"
                                    required
                                    :validate="validate"
                                    v-model="item.vinculo_categoria.in_regra_ordem" />
                            </div>
                        </div>

                        <div class="row" v-if="item.fl_permitir_lancamento && item.id_categoria && !item.vinculo_categoria">
                            <div class="col col-12">
                                <az-input
                                    type="select"
                                    label="Nível Hierárquico"
                                    required 
                                    :optionsList="lista_niveis_exibicao"
                                    optionsData="id_categoria"
                                    :validate="validate"
                                    v-model="item.id_categoria_mae" />
                            </div>
                        </div>

                        <div class="row" v-if="!item.id_categoria && !item.id_categoria_mae">
                            <div class="col col-12">
                                <az-input
                                    label="Tipo"
                                    placeholder="Selecione..."
                                    type="select"
                                    optionsMode="json"
                                    :optionsList="[
                                        { id: 'C', search: 'Entrada' },
                                        { id: 'D', search: 'Saída' }
                                    ]"
                                    optionsData="id"
                                    :edicao="!item.vinculo_categoria"
                                    required 
                                    :validate="validate"
                                    v-model="item.ch_natureza" />
                            </div>
                        </div>

                        <div class="row" v-else-if="!item.id_categoria && item.fl_permitir_lancamento">
                            <div class="col col-12">
                                <az-input
                                    label="Tipo"
                                    placeholder="Selecione..."
                                    type="select"
                                    optionsMode="json"
                                    :optionsList="[
                                        { id: 'C', search: 'Entrada' },
                                        { id: 'D', search: 'Saída' },
                                        { id: 'T', search: 'Transferência' }
                                    ]"
                                    optionsData="id"
                                    :edicao="!item.vinculo_categoria"
                                    required 
                                    :validate="validate"
                                    v-model="item.ch_natureza" />
                            </div>
                        </div>

                        <div class="row mt-2" v-if="item.fl_permitir_lancamento">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Operacional"
                                    :edicao="!item.vinculo_categoria"
                                    :validate="validate"
                                    v-model="item.fl_operacional" />
                            </div>
                        </div>

                        <div class="row" v-if="item.fl_permitir_lancamento"> <!-- && item.ch_natureza != 'T' -->
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    :label="( item.ch_natureza == 'C'
                                        ? 'Receita' 
                                        : ( item.ch_natureza == 'T' ? 'Transferência' : 'Despesa' ) ) + ' (Compõem DRE)'"
                                    :edicao="!item.vinculo_categoria"
                                    :validate="validate"
                                    v-model="item.fl_resultado" />
                            </div>
                        </div>

                        <!--
                        <div class="row" v-if="item.fl_permitir_lancamento && ( item.ch_natureza == 'C' || item.fl_redutora )">
                            <div class="col col-12">
                                <az-input
                                    type="checkbox-group"
                                    label="Redutora"
                                    :edicao="!item.id_categoria"
                                    :validate="validate"
                                    v-model="item.fl_redutora" />
                            </div>
                        </div>
                        -->

                        <div v-if="( item.fl_permitir_lancamento && ( item.ch_natureza == 'D' || item.fl_redutora ) ) || ( item.fl_formula )">
                            <div class="row"> 
                                <div class="col col-12">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Não Desembolsável"
                                        :edicao="!item.id_categoria && !item.vinculo_categoria && item.fl_permitir_lancamento"
                                        :validate="validate"
                                        v-model="item.fl_sem_desembolso" />
                                </div>
                            </div>
                        
                            <div class="row" v-if="item.fl_sem_desembolso">
                                <div class="col col-12">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Fórmula"
                                        :edicao="!item.id_categoria && !item.vinculo_categoria && item.fl_permitir_lancamento"
                                        :validate="validate"
                                        v-model="item.fl_formula" />
                                </div>
                            </div>

                            <div class="row" v-if="item.fl_formula">
                                <div class="col col-12">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Fórmula de Consolidação"
                                        :validate="validate"
                                        v-model="item.fl_formula_consolid" />

                                    <div class="alert alert-secondary small p-1" v-if="item.fl_formula_consolid">
                                        Fórmula de consolidação não é somada no resultado final.
                                    </div>
                                </div>
                            </div>

                            <div class="row" v-if="item.fl_formula">
                                <div class="col col-12">
                                    <az-input
                                        :edicao="!item.vinculo_categoria"
                                        label="Fórmula"
                                        placeholder="Ex.: #1 * 0.06"
                                        :validate="validate"
                                        v-model="item.st_formula" />
                                </div>
                            </div>

                            <div v-if="item.fl_sem_desembolso && item.fl_formula && item.st_formula">
                                <table class="table table-sm mt-3">
                                    <thead>
                                        <tr>
                                            <th>Id</th>
                                            <th>Descrição</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(categ, icx) in lista_categorias_formula(item.st_formula)" :key="icx">
                                            <td>{{ categ.tag }}</td>
                                            <td>{{ categ.st_categoria }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Código Externo"
                                    :validate="validate"
                                    v-model="item.st_codigo_externo" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Observação"
                                    type="textarea"
                                    :validate="validate"
                                    v-model="item.st_observacao" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="categoria" :id="item.id_categoria" v-if="item.id_categoria" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <button type="button" class="btn btn-danger" @click="remover_vinculo()" v-if="item.vinculo_categoria">Remover</button>
                        <az-submit @click="atualizar()">{{ item.id_categoria ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Tratamento de Modelos -->
        <div class="modal fade" id="modeloCategoriaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="edicao_modelo">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Modelo de Categorias
                            <span class="badge badge-secondary ml-2">
                                {{ edicao_modelo.id_modelo_categoria ? '#' + edicao_modelo.id_modelo_categoria : 'Novo' }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row">
                            <div class="col col-12 col-md-9">
                                <az-input   
                                    label="Título"
                                    required 
                                    :validate="validate"
                                    v-model="edicao_modelo.st_titulo" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input   
                                    label="Tipo"
                                    placeholder="Selecione..."
                                    type="select"
                                    :optionsList="[
                                        { id: 'D', search: 'DRE' },
                                        { id: 'F', search: 'Fluxo de Caixa' }
                                    ]"
                                    optionsData="id"
                                    required 
                                    :validate="validate"
                                    v-model="edicao_modelo.ch_tipo" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                                <az-input   
                                    label="Observações"
                                    type="textarea"
                                    :validate="validate"
                                    v-model="edicao_modelo.st_observacoes" />
                            </div>
                        </div>

                        <div class="form-row mt-3">
                            <div class="col col-12">
                                <az-input   
                                    sizing="sm"
                                    label="Não exibir totalização das categorias"
                                    type="checkbox-group"
                                    :validate="validate"
                                    v-model="edicao_modelo.fl_block_total" />

                                <div class="alert alert-secondary small p-1" v-if="edicao_modelo.fl_block_total">
                                    Normalmente essa opção é utilizada quando o valor total é exibido a partir de um campo fórmula.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizarModelo()">{{ edicao_modelo.id_modelo_categoria ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal paara Vínculo de Hierarquia -->
        <div class="modal fade" id="vinculoHierarquiaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="edicao_vinculo">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Categoria de {{ edicao_vinculo.mae.search }}
                            <span class="badge badge-secondary ml-2" v-if="edicao_vinculo.id_categoria">
                                #{{ edicao_vinculo.id_categoria }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info" v-if="modelo_selecionado">
                            {{ modelo_selecionado.st_titulo }}
                        </div>

                        <selecao-categoria 
                            :ch_tipo_lancamento="edicao_vinculo.natureza"
                            :validate="validate"
                            v-model="edicao_vinculo.id_categoria" />

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    type="number"
                                    placeholder="Ordem..."
                                    label="Ordem"
                                    required 
                                    :validate="validate"
                                    v-model="edicao_vinculo.in_regra_ordem" />
                            </div>
                        </div>

                        <br><br><br><br><br><br><br><br><br>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="modeloCategoriaVinculo" :id="edicao_vinculo.id_modelo_categoria_vinculo" v-if="edicao_vinculo.id_modelo_categoria_vinculo" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar_vinculo()">{{ edicao_vinculo.id_modelo_categoria_vinculo ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../../cadastros/shared/ConfigMainTitle.vue';
import AzBreakTitle from '../../util/AzBreakTitle';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import draggable from "vuedraggable";
import CategoriasHierarquia from '../shared/CategoriasHierarquia.vue';
import Importacao from '../shared/Importacao.vue';
import PrintExport from '../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import SelecaoCategoria from '../../modulos/financeiro/SelecaoCategoria.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            drag: false, 
            drag_cat: false, 
            operadoras: [], 
            grupos: [], 
            apuracao: 'P',
            viewMode: "A",
            search: "", 
            expansao: {},
            lista_niveis: null,
            tipo_aplic: 'G', 
            id_modelo_categoria: null, 
            modelos: [], 
            edicao_modelo: null, 
            modelo_selecionado: null, 
            edicao_vinculo: null, 
            expanded: false, 
        }
    },

    components: { 
        AzBreakTitle,
        ConfigMainTitle,
        AzInput,
        AzSubmit, 
        AzAuditLogButton, 
        draggable,
        CategoriasHierarquia, 
        Importacao, 
        PrintExport, 
        CabecalhoGenerico, 
        AzEmptyState,
        SelecaoCategoria, 
    },

    computed: { 
        lista_modelos: function () { 
            let reg = this.$util.getregex(this.search);

            return this.modelos.filter(item => this.viewMode == 'T' || item.fl_ativo)
                .filter(item => !this.search || reg.test(JSON.stringify(item)));
        },

        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return _.groupBy(
                    _.orderBy(
                        this.dados.filter(item => this.viewMode == 'T' || item.fl_ativa)
                            .filter(item => !this.search || reg.test(JSON.stringify(item)) ), 
                        'in_regra_ordem'
                    )
                    , 'ch_natureza'
                );
        },

        lista_niveis_exibicao: function () { 
            if ( !this.item || !this.lista_niveis )
                return [];

            return _.orderBy(
                this.lista_niveis, // .filter(nivel => ( nivel.ch_natureza == ( this.item.fl_redutora ? 'C' : this.item.ch_natureza ) )),
                'search' 
            );
        },

        dados_tabela: function () { 
            if ( !this.dados )
                return [];

            let nivel = 0;

            return this.dados.categorias.filter(item => item.ch_natureza == 'C')
                .flatMap(item => this.montar_categoria(item, nivel))
                .concat( 
                    this.dados.categorias.filter(item => item.ch_natureza == 'D')
                        .flatMap(item => this.montar_categoria(item, nivel))
                );
        }
    },

    methods: { 
        toggle_expanded (lista = null) { 
            if ( lista ) { 
                lista.forEach(item => { 
                    item.expanded = this.expanded;
                    this.$set(this.expansao, item.id_categoria, this.expanded);

                    if ( item.categorias && item.categorias.length ) { 
                        this.toggle_expanded(item.categorias);
                    }
                });

                return; 
            } 

            this.expanded = !this.expanded;

            this.dados.categorias.forEach(item => { 
                item.expanded = this.expanded;
                this.$set(this.expansao, item.id_categoria, this.expanded);

                if ( item.categorias && item.categorias.length ) { 
                    // this.toggle_expanded(item.categorias);
                }
            });

            this.$forceUpdate();
        },

        remover_vinculo () { 
            if ( !confirm('Confirma remover o vínculo da categoria?') ) { 
                return;
            }

            this.$util.remover(this, { 
                service: 'modelo_categoria_vinculos',
                dados: { 
                    id_modelo_categoria_vinculo: this.item.vinculo_categoria.id_modelo_categoria_vinculo
                },
                modal: 'categoriaModal',
                toast: true, 
                reload: true, 
            });
        },

        atualizar_vinculo () { 
            this.$util.atualizar(this, { 
                service: 'modelo_categoria_vinculos',
                func: 'store', 
                dados: this.edicao_vinculo,
                modal: 'vinculoHierarquiaModal',
                toast: true, 
                reload: true, 
            });
        },

        selecionar_modelo (modelo) { 
            this.dados = null; 
            this.id_modelo_categoria = modelo.id_modelo_categoria;
            this.modelo_selecionado = _.cloneDeep(modelo);

            this.$nextTick(() => { 
                this.load();
            });
        },

        editarModelo (modelo) { 
            this.edicao_modelo = _.cloneDeep(modelo);
            $('#modeloCategoriaModal').modal('show');
        },

        atualizarModelo () { 
            this.$util.atualizar(this, { 
                service: 'modelo_categorias',
                func: 'store', 
                dados: this.edicao_modelo,
                modal: 'modeloCategoriaModal',
                toast: true, 
                reload: true, 
            });
        },

        incluir_modelo () { 
            this.edicao_modelo = { 
                id_modelo_categoria: null,
                fl_ativo: true, 
                fl_padrao: false, 
                st_titulo: "",
                st_observacoes: "",
                ch_tipo: "", 
            };

            this.validate = false;

            $('#modeloCategoriaModal').modal('show');
        },

        trocar_tipo_aplic (tipo) { 
            this.tipo_aplic = null;

            this.$nextTick(() => { 
                this.tipo_aplic = tipo;
            });
        },
        lista_categorias_formula (text) { 

            const hashtagRegex = /#(\w+)/g;
            let hashtags = [];
            let match;

            while ((match = hashtagRegex.exec(text)) !== null) {
                hashtags.push(match[0]);
            }

            hashtags = _.uniq(hashtags);

            return hashtags.map(tag => { 
                let id = tag.slice(1);
                let categoria;
                if ( !isNaN(id) && this.dados_tabela ) { 
                    categoria = this.dados_tabela.find(categ => categ.id == id);
                }

                return {
                    tag: tag, 
                    id_categoria: categoria ? categoria.id : null, 
                    st_categoria: categoria ? categoria.descricao : '?', 
                };
            });

        },

        montar_categoria(item, nivel) { 
            if ( !item || !item.categorias ) { 
                return [];
            }

            let filhos = item.categorias.flatMap(categ => this.montar_categoria(categ, nivel + 1));

            return [{ 
                id: item.id_categoria, 
                descricao: '.'.repeat(nivel * 3) + item.search,
                nivel: nivel, 
                tipo: item.ch_natureza == 'C' ? 'Entrada' : 'Saída',
                ativo: item.fl_ativa ? 'S' : 'N', 
            }].concat(filhos);
        },

        expandir(item) { 
            this.$set(this.expansao, item.id_categoria, item.expanded);
        },

        atualizarCategoriaEntradas() { 
            if ( this.apuracao == 'O' ) { 

                this.$util.atualizar(this, { 
                    service: 'operadoras',
                    func: 'stores',
                    dados: { 
                        items: this.operadoras 
                    }, 
                    toast: true, 
                });

            }    
        },

        atualizarOrdem(chave) { 
            let idx = 1;

            this.lista[chave].forEach(item => {
                item.in_regra_ordem = ( ( item.ch_natureza == 'D' ? 1000 : 1 ) * (idx++) );
            });

            this.$util.atualizar(this, { 
                service: 'categorias', 
                func: 'ordem',
                dados: {
                    lista: this.lista[chave],
                },
            });
        },

        atualizarOrdemFilho(dado) { 
            let idx = 1;

            dado.categorias.forEach(item => {
                item.in_regra_ordem = ( ( item.ch_natureza == 'D' ? 1000 : 1 ) * (idx++) );
            });

            this.$util.atualizar(this, { 
                service: 'categorias', 
                func: 'ordem',
                dados: {
                    lista: dado.categorias,
                },
            });
        },

        editar_vinculo (item) { 
            this.validate = false;
            this.edicao_vinculo = null; 

            this.$nextTick(() => { 
                this.edicao_vinculo = _.cloneDeep(item);
                $('#vinculoHierarquiaModal').modal('show');
            });
        },

        incluirCategoria (mae, incluir_nivel = false, formula = false) { 
            if ( !incluir_nivel && !isNaN(this.id_modelo_categoria) && mae && !mae.formula && !formula) { 

                let item = { 
                    id_modelo_categoria_vinculo: null, 
                    id_modelo_categoria: this.id_modelo_categoria, 
                    id_categoria: "", 
                    id_categoria_mae: mae.id_categoria,
                    mae: mae, 
                    in_regra_ordem: 1000, 
                    natureza: mae.ch_natureza,
                };

                this.editar_vinculo(item);

                return;

            }

            this.validate = false; 

            let item = { 
                id_categoria: null, 
                id_categoria_mae: mae.id_categoria, 
                st_categoria: "", 
                ch_natureza: mae.ch_natureza,
                fl_ativa: true, 
                fl_permitir_exclusao: true,  
                categoria_mae: { 
                    search: mae.search, 
                },
                fl_permitir_lancamento: incluir_nivel ? false : true, 
                in_regra_ordem: 1000, 
                fl_resultado: true, 
                fl_operacional: true, 
                fl_redutora: false, 
                fl_sem_desembolso: false, 
            };

            if ( formula || ( mae && mae.formula ) ) { 
                item.fl_sem_desembolso = true;
                item.fl_formula = true;

                if ( !isNaN(this.id_modelo_categoria) ) { 
                    item.id_modelo_categoria = this.id_modelo_categoria;
                }
            }

            this.editar(item);
        },

        incluirSubCategoria (mae) { 
            this.incluirCategoria(mae, true);
        },

        editar (item) { 
            this.item = _.cloneDeep(item);
            $('[data-toggle="tooltip"]').tooltip('hide');
            $('#categoriaModal').modal('show');
        },

        load () { 
            if ( this.id_modelo_categoria ) { 

                this.$util.load(this, { 
                    service: 'categorias',
                    parms: { 
                        cadastro: true, 
                        id_modelo_categoria: this.id_modelo_categoria, 
                    },
                    loadTo: res => { 
                        this.dados = { 
                            categorias: res,
                        };
                    }
                });

                this.$util.load(this, { 
                    service: 'categorias',
                    parms: { 
                        niveis: true, 
                        id_modelo_categoria: this.id_modelo_categoria, 
                    },
                    loadTo: res => { 
                        this.lista_niveis = res;
                    }
                });

            } else { 

                this.$util.load(this, { 
                    service: 'modelo_categorias',
                    parms: { 
                        cadastro: true, 
                    },
                    loadTo: res => { 
                        res.unshift({ id_modelo_categoria: 'B', st_titulo: 'Modelo Base', search: 'Modelo Base', ch_tipo: 'B', fl_ativo: true });
                        this.modelos = res;
                    }
                });

            }
                
            this.$util.load(this, { 
                service: 'operadoras',
                func: 'index',
                parms: { 
                    categorias: true 
                }, 
                loadTo: res => { 
                    this.operadoras = res;
                }                
            });

            this.$util.load(this, { 
                service: 'grupo_procedimentos',
                func: 'index',
                loadTo: res => { 
                    this.grupos = res;
                }                
            });
        },

        toggle_modelo (item) { 
            this.$util.toggle(this, { 
                service: 'modelo_categorias',
                dados: item, 
                callback: () => { 
                    this.load();
                }
            });
        },

        toggle (item) { 
            this.$util.toggle(this, { 
                service: 'categorias',
                dados: item, 
                callback: () => { 
                    this.load();
                }
            });
        },

        atualizar () { 
            if ( this.item.vinculo_categoria ) { 
                this.$util.atualizar (this, { 
                    service: 'modelo_categoria_vinculos',
                    dados: { 
                        ...this.item.vinculo_categoria,
                    },
                    modal: 'categoriaModal', 
                    reload: true,   
                });
                return;
            }

            this.$util.atualizar (this, { 
                service: 'categorias',
                dados: { 
                    ...this.item, 
                    id_modelo_categoria: isNaN(this.id_modelo_categoria) ? null : this.id_modelo_categoria,
                },
                modal: 'categoriaModal', 
                reload: true,   
            });
        },

    },

    created() { 
        this.apuracao = this.$store.state.unidade.parametro_unidade.fl_receita_por_operadora ? 'O' : 'P';
    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Categorias Financeiras", path: "" },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);
    },

    updated () { 
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
        });
    }
}
</script>